export default () => {

    document.querySelectorAll('.js-btn-groupTab').forEach(item => {
        item.addEventListener('click', event => {
            event.preventDefault();
            document.querySelectorAll('.js-btn-groupTab').forEach(btn => {
                btn.classList.remove("focus");
            });
            document.querySelectorAll('.c-groupTab-list').forEach(group => {
                group.classList.remove("focus");
            });
            let id = item.getAttribute("data-tab");
            item.classList.toggle("focus");
            let rowMaterialList = document.querySelector('#'+id);
            //handle click
            if(rowMaterialList){
                rowMaterialList.classList.toggle("focus");
            }
        });
    });
};
